import { FlowStepActionFunction } from '../flow-engine';
import { APIContextActions } from '../../api/APIContext';
import history from '../../routing/BrowserHistory';

export const action: FlowStepActionFunction = function useAction(_apiActions: APIContextActions): void {
  history.replace('/end-of-redemption-period');
};
